import React, { PureComponent } from 'react'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { Modal } from 'hljd'
import styles from './style.module.less'

export default class extends PureComponent {
  static defaultProps = {
    tip: '成功',
    icon: 'check-circle',
    status_text: ''
  }
  render() {
    const { isShow, width, icon, tip, status_text } = this.props
    return (
      <Modal visible={isShow} footer={null} closable={false} width={width}>
        <div className={styles.wrap}>
          <p className={styles.icon}>
            {icon === 'check-circle' ? (
              <LegacyIcon type={icon} style={{ color: '#80D089' }} />
            ) : (
              <LegacyIcon type={icon} style={{ color: '#FF8C30' }} />
            )}
            {status_text ? (
              <span
                style={{
                  fontSize: 20,
                  verticalAlign: 'middle',
                  marginLeft: 10
                }}
              >
                {status_text}
              </span>
            ) : null}
          </p>
          <p className={styles.tip}>{tip}</p>
        </div>
      </Modal>
    )
  }
}
